/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

// Import pages
import Userpage from '@/views/Userpage'
import UserDetail from '@/views/UserDetail'
import Login from '@/components/Login'
import Npos from '@/views/Npos'
import NpoDetail from '@/views/NpoDetail'
import Clients from '@/views/Clients'
import ClientDetail from '@/views/ClientDetail'
import Merchants from '@/views/Merchants'
import MerchantDetail from '@/views/MerchantDetail'
import VoteQrcode from '@/views/VoteQrcode'
import Campaigns from '@/views/Campaigns'
import CampaignDetail from '@/views/CampaignDetail'
import GiftCardsDetail from '@/views/gift-cards/GiftCardsDetail'
import Users from '@/views/Users'
import Donations from '@/views/Donations'
import Dashboard from '@/views/Dashboard'
import AddUser from '@/views/AddUser'
import RegisterNpo from '@/views/RegisterNpo'
import Messages from '@/views/Messages'
import NposComponent from '@/components/npos/ComponentNpoTable'

// QrcodeVotes
import QrcodeValidate from '@/views/qrcodevote/QrcodeValidate'
import QrcodeNpos from '@/views/qrcodevote/QrcodeNpos'
import QrcodeNpo from '@/views/qrcodevote/QrcodeNpo'
import QrcodeVoteSuccess from '@/views/qrcodevote/QrcodeVoteSuccess'
import QrcodeValidateLeadEmail from '@/views/qrcodevote/QrcodeValidateLeadMail'

// Survey
import Survey from '@/views/qrcodevote/survey-app/SurveyBody'
import SurveyResult from '@/views/qrcodevote/survey-app/SurveyVoteResult'

// Gift card
import GiftCardNpoList from '@/views/qrcodevote/giftcard-app/NpoList'
import GiftCardNpoDetail from '@/views/qrcodevote/giftcard-app/NpoDetail'

// Npo onboarding
import NpoRegistration from '@/views/onboarding/NpoRegistrationConfirmed'

export default [
  // User
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      public: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      public: true
    }
  },
  // Onboarding Npo
  {
    path: '/npo-confirm/:npoToken',
    name: 'npoconfirm',
    component: NpoRegistration,
    meta: {
      public: true
    }
  },
  // Pages
  {
    path: '/donations',
    name: 'donations',
    component: Donations,
    meta: {
      public: false
    }
  },
  {
    path: '/clients',
    name: 'clients',
    component: Clients,
    meta: {
      public: false
    }
  },
  {
    path: '/clients/:clientId',
    name: 'clientdetail',
    component: ClientDetail,
    meta: {
      public: false,
      clientAuth: true
    }
  },
  {
    path: '/merchants',
    name: 'merchants',
    component: Merchants,
    meta: {
      public: false
    }
  },
  {
    path: '/merchants/:merchantId',
    name: 'merchantdetail',
    component: MerchantDetail,
    meta: {
      public: false,
      clientAuth: true,
      merchantAuth: true
    }
  },
  {
    path: '/users/:userId',
    name: 'userdetail',
    component: UserDetail,
    meta: {
      public: false,
      clientAuth: true,
      merchantAuth: true
    }
  },
  {
    path: '/vote-qrcode',
    name: 'voteqrcode',
    component: VoteQrcode,
    meta: {
      public: false
    }
  },
  {
    path: '/campaigns',
    name: 'campaigns',
    component: Campaigns,
    meta: {
      public: false
    }
  },
  {
    path: '/campaigns/:campaignId',
    name: 'campaigndetail',
    component: CampaignDetail,
    meta: {
      public: false,
      clientAuth: true,
      merchantAuth: true
    }
  },
  {
    path: '/campaigns/:campaignId/gift-cards',
    name: 'campaigngiftcards',
    component: GiftCardsDetail,
    meta: {
      public: false
    }
  },
  {
    path: '/npos',
    name: 'npos',
    component: Npos,
    meta: {
      public: false
    }
  },
  {
    path: '/npos-component',
    name: 'nposcomp',
    component: NposComponent,
    meta: {
      public: false
    }
  },
  {
    path: '/npos/:npoId',
    name: 'npodetail',
    component: NpoDetail,
    meta: {
      public: false
    }
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      public: false
    }
  },
  {
    path: '/user',
    name: 'userpage',
    component: Userpage,
    meta: {
      clientAuth: true,
      npoAuth: true
    }
  },
  {
    path: '/add-user',
    name: 'adduser',
    component: AddUser,
    meta: {
      public: false
    }
  },
  {
    path: '/register-npo',
    name: 'registernpo',
    component: RegisterNpo,
    meta: {
      public: false
    }
  },

  // Gift card http://localhost:8080/giftcards/validate/miWotBWZIDB9-Q-KUDHSmvkfAfAZ4ADLlYl3HCMLbz4
  {
    path: '/giftcards/validate/:giftCardToken',
    name: 'giftcardvalidate',
    component: QrcodeValidate,
    meta: {
      public: true
    }
  },
  {
    path: '/giftcards/:campaignId/:token',
    name: 'giftcardnpolist',
    component: GiftCardNpoList,
    meta: {
      public: true
    }
  },
  {
    path: '/qrcode-npo/:npoId/:token/:leadId?',
    name: 'giftcardnpodetail',
    component: GiftCardNpoDetail,
    beforeEnter: (to, from, next) => {
      if (from.name === 'giftcardnpodetail') {
        next(false)
      } else {
        next()
      }
    },
    props: true,
    meta: {
      public: true
    }
  },
  // Raccolta voti
  {
    path: '/qrcode/validate/:qrcodeToken',
    name: 'qrcodevote',
    component: QrcodeValidate,
    meta: {
      public: true
    }
  },
  {
    path: '/validate-lead-email/:token',
    name: 'validateleademail',
    component: QrcodeValidateLeadEmail,
    meta: {
      public: true
    }
  },
  {
    path: '/qrcode-npos/:campaignId/:token/:leadId?',
    name: 'qrcodenpos',
    component: QrcodeNpos,
    meta: {
      public: true
    }
  },
  {
    path: '/qrcode-npo/:npoId/:token/:leadId?',
    name: 'qrcodenpo',
    component: QrcodeNpo,
    beforeEnter: (to, from, next) => {
      if (from.name === 'qrcodenpo') {
        next(false)
      } else {
        next()
      }
    },
    props: true,
    meta: {
      public: true
    }
  },
  {
    path: '/survey/result/:campaignId/:token',
    name: 'qrcodesurveyresult',
    component: SurveyResult,
    meta: {
      public: true
    }
  },
  {
    path: '/survey/:campaignId/:token/:leadId?',
    name: 'qrcodesurvey',
    component: Survey,
    meta: {
      public: true
    }
  },
  {
    path: '/qrcode-vote-success',
    name: 'qrcodevotesuccess',
    component: QrcodeVoteSuccess,
    meta: {
      public: true
    }
  },
  {
    path: '/qrcode-vote-error',
    name: 'qrcodevoteerror',
    component: QrcodeNpo,
    meta: {
      public: true
    }
  },
  {
    path: '/messages',
    name: 'messages',
    component: Messages,
    meta: {
      public: false,
      clientAuth: true,
      merchantAuth: true
    }
  },
  // TO DO insert 404 page
  { path: '*', redirect: '/' } // otherwise redirect to home
]
